import {
    PromoCodeValidationQueryPromoCodeValidation,
    Maybe,
    OrderItemPricing2,
    OrderItemTax2,
} from "../../graphql/generated-types"

export interface CartProduct {
    id: string
    productId: string
    quantity: number
    activeModifiers?: CartProductModifier[]
    note?: Maybe<string>
    customPrice?: number
    orderItemPricings?: OrderItemPricing2[]
    orderItemTaxes?: OrderItemTax2[]
    isExistingOrderItem?: boolean
}

export enum CartProductModifierTypeEnum {
    option = "option",
    modifier = "modifier",
}
export interface CartProductModifier {
    productId: string
    type: CartProductModifierTypeEnum
    modifierGroupId: string
    quantity: number
    customPrice?: Maybe<number>
    parentModifierGroupType?: Maybe<CartProductModifierTypeEnum>
    parentModifierId?: Maybe<string>
    parentModifierGroupId?: Maybe<string>
}

export interface CardProgramCard {
    id: string
    key: string
    valueRemaining: number
}

export type PromoSpecialPricing = PromoCodeValidationQueryPromoCodeValidation
